<template>
	<div class="pa-5">
		<v-container fluid>
			<div class="d-flex justify-space-between">
				<div>
					<pre><strong>{{incident.premiseName}}</strong> {{incident.trackingNumber}} {{incident.eventText}} - Created On <date-time-display v-bind:date="incident.dateTime"/> By {{incident.userName}} {{formatPhone()}}</pre>
				</div>
				<div>
					<v-btn outlined type="button" class="mx-2" @click="goBack()"  color="warning"  dark>Go Back</v-btn>
				</div>
			</div>
		</v-container>
		<div>
			<div v-if="loading" style="text-align: center; margin-top:200px">
				<v-progress-circular
				    :width="3"
				    color="green"
				    indeterminate=""/>
			</div>
			<div v-if="!loading">
				<v-row v-for="message in messages" :key="message.id">
					<v-col cols="12">
						<div class="d-flex justify-space-between">
							<div class="creator-name">{{message.creatorName}}</div>
							<div class="creator-date"><date-time-display v-bind:date="message.date"></date-time-display></div>
						</div>

						<v-card class="message-bubble" color="blue lighten-5">
							{{message.message}}
						</v-card>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import api from '@/api';
import DateTimeDisplay from "@/components/common/DateTimeDisplay";

export default {
	name: "IncidentCommunications",
	components : {DateTimeDisplay},
	data () {
		return {
			incident : {},
			loading : true,
			messages : []
		}
	},
	mounted() {
		this.getData().then(()=> {
			this.loading = false;
		},() => {
			alert("Error Loading Required Data");
		});
	},
	methods : {
		goBack() {
			this.$router.go(-1);
		},
		formatPhone() {
			if (this.incident.phoneNumber) {
				let ph = this.incident.phoneNumber.replaceAll(/[^\d]*/g,'');
				if (ph.length == 10) {
					return `(${ph.substring(0,3)}) ${ph.substring(3,6)} - ${ph.substring(6)}`
				}
				return ph;
			}

			return '';
		},
		getData() {
			return new Promise((resolve,reject) => {
				api.incident.get(this.$route.params.cadRequestId).then((data) => {
					this.incident = data;
					api.incident.message.get(this.$route.params.cadRequestId).then((data) => {
						this.messages = data;
						resolve();
					});

				});
			});
		}
	}
}
</script>

<style scoped>

.message-bubble {
	padding: 10px;
	text-align: center;
	font-size:1em;
	font-family: arial;
	position:relative;
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
	text-align:left;
}

.creator-name, .creator-date {
	color:black;
	padding:2px;
	font-size:12px;
}
</style>